export default __webpack_public_path__ + "static/media/cloud-upload.66569db4.svg";